import type { LinkProps as ReactRouterLinkProps } from "react-router-dom";
import { Link as ReactRouterLink } from "react-router-dom";

export type LinkProps = ReactRouterLinkProps;
export const Link = ReactRouterLink;
